import React from "react";
import { useTheme } from "@mui/material/styles";

import SubdirectoryArrowRightIcon from "@mui/icons-material/SubdirectoryArrowRight";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { getType, types } from "../itemTypes";
import { useTranslation } from "react-i18next";
import useClasses from "../../useClasses";

const styles = (theme) => ({
  conditionalInfo: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    width: "100%",
    marginBottom: theme.spacing(2),
    fontFamily: theme.typography.body2.fontFamily,
    fontWeight: theme.typography.body2.fontWeight,
    fontSize: theme.typography.body2.fontSize,
    lineHeight: theme.typography.body2.lineHeight,
    letterSpacing: theme.typography.body2.letterSpacing,
    borderRadius: theme.shape.borderRadius,
    color: theme.palette.text.secondary,
  },
});

function ConditionalMessage({
  parentQuestion,
  conditions,
  isConditional,
  handleConditionalDialogOpen,
}) {
  const classes = useClasses(styles);
  const theme = useTheme();
  const { t } = useTranslation();

  const customStyles = {
    empty: {
      buttonVariant: "outlined",
      buttonColor: "secondary",
    },
    selected: {
      buttonVariant: "text",
      buttonColor: "inherit",
    },
  };

  const getCondition = () => {
    let message = t("editor.errors.chooseCondition");
    let style = customStyles.empty;
    switch (getType(parentQuestion?.type)) {
      case types.choice:
        const titles = parentQuestion.options
          .filter((option) => conditions.includes(option.id))
          .map((option) => option.title);
        if (titles.length > 0) {
          message = titles.map((title, index) =>
            titles.length === 0 || index === titles.length - 1
              ? title
              : `${title}, `
          );
          style = customStyles.selected;
        }
        break;

      case types.slider:
        if (conditions?.length > 1) {
          message = `${t("editor.conditionalDialog.between")} ${
            conditions[0].value
          } ${t("editor.conditionalDialog.and")} ${conditions[1].value}`;
          style = customStyles.selected;
        }
        break;

      default:
        break;
    }
    return { message: message, style: style };
  };
  const condition = getCondition();

  // only show conditional information when parent is a choice or slider type
  if (
    isConditional &&
    [types.choice, types.slider].includes(getType(parentQuestion.type))
  ) {
    return (
      <div className={classes.conditionalInfo}>
        <SubdirectoryArrowRightIcon
          style={{
            marginLeft: theme.spacing(2),
            marginRight: theme.spacing(1),
          }}
          fontSize="small"
        />
        <Typography>{t("editor.conditionalDialog.askedIf")}</Typography>
        <Button
          variant={condition.style.buttonVariant}
          color={condition.style.buttonColor}
          onClick={handleConditionalDialogOpen}
          endIcon={<ArrowDropDownIcon />}
        >
          <Typography
            noWrap
            style={{
              alignItems: "center",
              maxWidth: 200,
            }}
          >
            {condition.message}
          </Typography>
        </Button>
      </div>
    );
  }
  return null;
}

export default ConditionalMessage;
